// src/components/OrangeSlice.js
// Brand mascot: a single orange-slice illustration + a decorative
// scatter of slices used behind the hero. Terracotta accent (#E8734A).
import React from 'react';

/** One orange-slice mark. Pass `className` for size/position, `tone` for color. */
export const OrangeSlice = ({ className = '', tone = '#F29200', style }) => (
  <svg
    viewBox="0 0 100 100"
    className={className}
    style={style}
    aria-hidden="true"
    fill="none"
  >
    {/* rind */}
    <circle cx="50" cy="50" r="46" fill={tone} opacity="0.14" />
    <circle cx="50" cy="50" r="46" stroke={tone} strokeWidth="3" />
    {/* pith ring */}
    <circle cx="50" cy="50" r="36" stroke={tone} strokeWidth="2" opacity="0.85" />
    {/* segments */}
    <g stroke={tone} strokeWidth="1.8" opacity="0.9">
      <line x1="50" y1="14" x2="50" y2="86" />
      <line x1="14" y1="50" x2="86" y2="50" />
      <line x1="24.6" y1="24.6" x2="75.4" y2="75.4" />
      <line x1="75.4" y1="24.6" x2="24.6" y2="75.4" />
    </g>
    {/* seeds */}
    <g fill={tone} opacity="0.55">
      <circle cx="50" cy="26" r="2.2" />
      <circle cx="50" cy="74" r="2.2" />
      <circle cx="26" cy="50" r="2.2" />
      <circle cx="74" cy="50" r="2.2" />
    </g>
    <circle cx="50" cy="50" r="3" fill={tone} />
  </svg>
);

/** Decorative scatter of slices — absolute-positioned, non-interactive.
 *  Drop inside a `relative` container (e.g. the hero). */
export const OrangeScatter = ({ className = '' }) => (
  <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
    <OrangeSlice className="absolute -top-8 -left-10 w-40 opacity-[0.10] rotate-12" />
    <OrangeSlice className="absolute top-1/3 -right-12 w-56 opacity-[0.08] -rotate-6" />
    <OrangeSlice className="absolute bottom-4 left-1/4 w-24 opacity-[0.10] rotate-45" />
    <OrangeSlice className="absolute -bottom-10 right-1/3 w-36 opacity-[0.07] -rotate-12" />
  </div>
);

export default OrangeSlice;
